import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DataService {
  constructor() {}
  getCategories(): any[] {
    return [
      { id: "all", name: "All" },
      { id: "apps", name: "Apps" },
      { id: "sliders", name: "Sliders" },
      { id: "loaders", name: "Loaders" },
      { id: "utilities", name: "Utilities" },
      { id: "random", name: "Random Fun" },
    ];
  }
  appTypeProjects(): any[] {
    return [
      {
        name: "Analog Clock",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/analog-clock/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/analog-clock",
        image: "/assets/images/projects/analog-clock.png",
        category: "apps",
      },
      {
        name: "Drawing App",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/drawing-pad/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/drawing-pad",
        image: "/assets/images/projects/drawing.png",
        category: "apps",
      },
      {
        name: "Drink Water App",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/drink-water-app",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/drink-water-app",
        image: "/assets/images/projects/drink-water.png",
        category: "apps",
      },
      {
        name: "Note Taking App",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/notes-app/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/notes-app",
        image: "/assets/images/projects/notes.png",
        category: "apps",
      },
      {
        name: "Password Generator",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/password-generator",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/password-generator",
        image: "/assets/images/projects/password-generator.png",
        category: "apps",
      },
    ];
  }

  sliderTypeProjects(): any[] {
    return [
      {
        name: "Background Slider",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/background-slider/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/background-slider",
        image: "/assets/images/projects/background-slider.png",
        category: "sliders",
      },
      {
        name: "Vertical Slider",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/vertical-slider/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/vertical-slider",
        image: "/assets/images/projects/vertical-slider.png",
        category: "sliders",
      },
    ];
  }

  loaderTypeProjects(): any[] {
    return [
      {
        name: "Content Loader",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/content-placeholder/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/content-placeholder",
        image: "/assets/images/projects/content-loader.png",
        category: "loaders",
      },
      {
        name: "Loading Icon",
        liveDemoLink: " https://dev-vikasgupta.netlify.app/loading-icon",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/loading-icon",
        image: "/assets/images/projects/loading-icon.png",
        category: "loaders",
      },
      {
        name: "Lazy loading",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/lazy-loading",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/lazy-loading",
        image: "/assets/images/projects/lazy-loading.png",
        category: "loaders",
      },
    ];
  }

  utilityTypeProjects(): any[] {
    return [
      {
        name: "Accordians",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/accordians",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/accordians",
        image: "/assets/images/projects/accordian.png",
        category: "utilities",
      },
      {
        name: "Custom CheckBox",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/custom-checkboxes",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/custom-checkboxes",
        image: "/assets/images/projects/custom-checkbox.png",
        category: "utilities",
      },
      {
        name: "Search Widget",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/short-input-widget",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/short-input-widget",
        image: "/assets/images/projects/search-widget.png",
        category: "utilities",
      },
      {
        name: "Toast Notification",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/toast-notification/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/toast-notification",
        image: "/assets/images/projects/toast-notification.png",
        category: "utilities",
      },
    ];
  }

  randomTypeProjects(): any[] {
    return [
      {
        name: "Animated Counters",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/animated-counter",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/animated-counter",
        image: "/assets/images/projects/animated-counters.png",
        category: "random",
      },
      {
        name: "Auto Typing Effect",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/auto-typing-effect/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/auto-typing-effect",
        image: "/assets/images/projects/auto-typing-effect.png",
        category: "random",
      },
      {
        name: "Button Ripple Effect",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/ripple-effect",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/ripple-effect",
        image: "/assets/images/projects/drink-water.png",
        category: "random",
      },
      {
        name: "Nav Animation",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/nav-animation/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/nav-animation",
        image: "/assets/images/projects/nav-animation.png",
        category: "random",
      },
      {
        name: "Side Menu Animation",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/menu-animation",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/menu-animation",
        image: "/assets/images/projects/side-menu-animation.png",
        category: "random",
      },
      {
        name: "Product Compare",
        liveDemoLink: "https://dev-vikasgupta.netlify.app/split-landing-page/",
        githubLink:
          "https://github.com/dev-vikasgupta/design-kicks/tree/master/split-landing-page",
        image: "/assets/images/projects/split-landing-page.png",
        category: "random",
      },
    ];
  }

  projectList(): any[] {
    return [
      ...this.appTypeProjects(),
      ...this.sliderTypeProjects(),
      ...this.loaderTypeProjects(),
      ...this.utilityTypeProjects(),
      ...this.randomTypeProjects(),
    ];
  }
}
